import { Modal, Button } from '../../../shared/components';

interface CancelActivityModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

/**
 * Confirmacion antes de "Cancelar Actividad" (reemplaza al viejo boton de
 * Pausar/Despausar). Se pausaba sin dejar rastro auditable de cuanto tiempo
 * estuvo pausado ni por que - ahora en su lugar se cancela por completo: el
 * cronometro vuelve a "sin iniciar", se descarta la actividad/observaciones
 * en curso, y se redirige a Inicio. Se pide confirmacion porque es una
 * accion destructiva (se pierde el tiempo transcurrido).
 */
export function CancelActivityModal({ open, onClose, onConfirm }: CancelActivityModalProps) {
  return (
    <Modal open={open} onClose={onClose} title="Cancelar actividad">
      <div className="space-y-4">
        <p className="text-sm text-ink-600">¿Seguro que quieres cancelar? Se perderá el tiempo registrado.</p>
        <div className="flex gap-3 pt-2">
          <Button variant="outline" fullWidth onClick={onClose}>No</Button>
          <Button variant="danger" fullWidth onClick={onConfirm}>Sí, cancelar</Button>
        </div>
      </div>
    </Modal>
  );
}
